import HeadingComponent from "./HeadingComponent";
type VideoProps = {
  headingText?: string;
  src?: string;
  backgroundColor?: boolean;
  maxWidth?: string;
  videoWidth?: string;
};

const VideoComponent = ({
  headingText,
  src,
  backgroundColor,
  maxWidth,
  videoWidth
}: VideoProps) => {
  return (
    <div className="video-container">
      {headingText && (
        <HeadingComponent
          margin="32px 0 24px 0"
          headingText={headingText}
        ></HeadingComponent>
      )}
      <iframe
        className="video"
        src={src}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        width={videoWidth}
      />
      <style jsx>{`
        .video-container {
          background-color: ${backgroundColor ? "none" : "var(--color-white)"};
          display: flex;
          flex-direction: column;
          align-items: center;
          max-width: ${maxWidth ? maxWidth : "640px"};
        }
        .video {
          ${videoWidth ? "" : "width: 90%"};
          height: 360px;
          max-width: 640px;
          padding-bottom: 32px;
        }
        @media only screen and (max-width: 630px) {
          .video {
            width: 80%;
            height: inherit;
            min-height: 185px;
          }
        }
      `}</style>
    </div>
  );
};
export default VideoComponent;
